<!-- **
  * 显示样式参考 空调系统能效界面
* -->
<template>
  <div v-if="!useMutipleParams && listData.length > 0" :class="classObject">
    <div
      :style="{ width: listData.length === 1 ? '100%' : '' }"
      v-for="(v, i) in listData"
      :key="i"
    >
      <div class="title">{{ v.name }}</div>
      <div class="content">
        <div class="firstDiv">
          <div v-if="!!v.realUnit">
            <span>{{ `${v.realName || realNameDefault}(${v.realUnit})` }}</span>
          </div>
          <div v-else>
            <span>{{ v.realName || realNameDefault }}</span>
          </div>
        </div>
        <div class="secondDiv">
          <span :title="v.realValue" class="highlight">{{
            dealBigNum(dealNumWith(v.realValue, 2))
          }}</span>
        </div>
        <div class="thirdDiv">
          <div v-if="!!v.rateUnit">
            <span>{{ `${v.rateName || rateNameDefault}(${v.rateUnit})` }}</span>
          </div>
          <div v-else>
            <span>{{ v.rateName || rateNameDefault }}</span>
          </div>
          <div class="value">
            <span :title="v.rateValue">{{ dealBigNum(v.rateValue) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="useMutipleParams" :class="classObject">
    <div>
      <div class="title">{{ mutipleData.name }}</div>
      <div class="content">
        <div
          class="content-item"
          v-for="(v, i) in mutipleData.params"
          :key="i"
          :style="{ width: mutipleData.params.length === 1 ? '100%' : '' }"
        >
          <div class="firstDiv">
            <div v-if="!!v.realUnit">
              <span>{{
                `${v.realName || realNameDefault}(${v.realUnit})`
              }}</span>
            </div>
            <div v-else>
              <span>{{ v.realName || realNameDefault }}</span>
            </div>
          </div>
          <div class="secondDiv">
            <span :title="v.realValue" class="highlight">{{
              dealBigNum(dealNumWith(v.realValue, 2))
            }}</span>
          </div>
          <div class="thirdDiv">
            <div v-if="!!v.rateUnit">
              <span>{{
                `${v.rateName || rateNameDefault}(${v.rateUnit})`
              }}</span>
            </div>
            <div v-else>
              <span>{{ v.rateName || rateNameDefault }}</span>
            </div>
            <div class="value">
              <span :title="v.rateValue">{{ dealBigNum(v.rateValue) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const classNames = require("classnames");
import { dealBigNum, dealNumWith } from "@/assets/js/utils";
import TitleTipsItem from "@/components/TitleTips/TitleTipsItem.vue";
export default {
  components: { TitleTipsItem },
  name: "HeadTipsGroup",
  props: {
    listData: {
      type: Array,
      default: () => [],
    },
    twoLine: {
      type: Boolean,
      default: false,
    },
    className: {
      type: String,
      default: "",
    },
    mutipleData: {
      type: Object,
      default: () => ({}),
    },
    useMutipleParams: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      listColor: [
        "#279fff",
        "#29c444",
        "#fecc2b",
        "#7472fc",
        "#279fff",
        "#29c444",
        "#fecc2b",
      ],
      value: false,
      realNameDefault: "实时功率",
      rateNameDefault: "额定功率",
    };
  },
  computed: {
    classObject: function () {
      return classNames({
        headTipsGroup: !this.useMutipleParams,
        headTipsGroupMutiple: this.useMutipleParams,
        twoLine: this.twoLine,
        [this.className]: !!this.className,
      });
    },
  },
  methods: {
    dealBigNum,
    dealNumWith,
  },
};
</script>

<style lang="scss" scoped>
.headTipsGroup {
  padding: 0 32px;
  width: calc(100% - 64px);
  height: 100%;
  @include setFlexBetween;

  & > div {
    background: #ffffff;
    border-radius: 8px;
    border: 2px solid #f4f6f7;
    width: 350px;
    height: 150px;

    .title {
      color: #666666;
      font-size: 20px;
      font-weight: bold;
      height: 40px;
      background: #f4f6f7;
      border-radius: 8px 8px 0px 0px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .content {
      height: 110px;
      @include setFlexColumn;
      align-items: center;
      justify-content: center;

      & > div {
        width: 100%;
        display: flex;
        justify-content: center;
      }

      .firstDiv {
        font-size: 18px;
        font-weight: bold;
      }

      .secondDiv {
        margin-top: 8px;

        .highlight {
          color: #28cccb;
          font-weight: bold;
          font-size: 30px;
        }
      }

      .thirdDiv {
        margin-top: 8px;
        font-size: 14px;
        font-weight: bold;
        @include setFlexCenter;

        .value {
          margin-left: 10px;
        }
      }
    }
  }
}

.headTipsGroupMutiple {
  background: #ffffff;
  padding: 0 32px;
  width: calc(100% - 64px);
  height: 100%;
  & > div {
    border-radius: 0.041667rem;
    border: 0.010417rem solid #f4f6f7;
    .title {
      color: #666666;
      font-size: 20px;
      font-weight: bold;
      height: 40px;
      background: #f4f6f7;
      border-radius: 8px 8px 0px 0px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .content {
      width: 100%;
      height: 110px;
      @include setFlexAround;
      &-item {
        width: 350px;
        height: 100%;
        @include setFlexColumn;
        align-items: center;
        justify-content: center;

        & > div {
          width: 100%;
          display: flex;
          justify-content: center;
        }

        .firstDiv {
          font-size: 18px;
          font-weight: bold;
        }

        .secondDiv {
          margin-top: 8px;

          .highlight {
            color: #28cccb;
            font-weight: bold;
            font-size: 30px;
          }
        }

        .thirdDiv {
          margin-top: 8px;
          font-size: 14px;
          font-weight: bold;
          @include setFlexCenter;

          .value {
            margin-left: 10px;
          }
        }
      }
    }
  }
}

.twoLine {
  flex-wrap: wrap;
}

::v-deep .headTipsBtnItem > div .itemName {
  font-weight: 400;
  color: #666;
}
</style>
